import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CustomizeSelectData from 'component/customize_select/customize_select';
import CustomLayout from 'component/layout/custom_layout';
import SelectMultipleDropDown, { SelectOption } from 'component/StandardDropDownCheckBox';
import { StandardTextFieldStyle } from 'component/StandardTextFieldStyle';
import { GET_CATEGORY } from 'graph_ql/category-tag/category/queries';
import { GET_TAG } from 'graph_ql/category-tag/tag/queries';
import { UPDATE_STYLE } from 'graph_ql/createStyle/mutation';
import { GET_PERSONAS } from 'graph_ql/personas/queries';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import {
    clearLastCreatedStyleInfo,
    IStyleInformation,
    setLastCreatedStyleInfo,
} from 'redux/create-style/create-style.slice';
import { useAppDispatch, useAppSelector } from 'redux/store';
import { PATH } from '../../../routes/constant';
import { ItemStatus } from '../../style_detail/constant';
import { GET_QUESTION_DATA } from 'graph_ql/getQuiz/queries';
import { Spinner } from 'react-bootstrap';
import _, { get, isEqual, omit } from 'lodash';
import StandardPopup from 'component/StandardPopup';
import { ToastType } from 'constants/toast';
import './index.scss';
import utils, { getValueSelect } from 'utils/utils';
import { Theme } from 'react-toastify';
import ModalFull, { ETitleModal } from 'component/modal_full_screen';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import { TaffiSubjects } from 'types/subjects';
import themes from 'styles/themes';
import WidgetPopup from 'component/popup/customize_popup';
import { WidgetCode } from 'component/popup/constant';
import UserType from 'constants/user';
import { INAPPROPRIATE_LAYOUT_FEEDBACK_VALUE, StyleReviewAction } from '../../../constants/style_review';
import { setLastReviewStyleIds } from '../../../redux/style_review';
import { ReactionType, STRINGS } from '../../../constants';
import { PRODUCT_TYPE } from '../../../utils/analytics';
import { TOGGLE_REACTION } from 'graph_ql/reaction/mutations';
import { GET_FEEDBACK_OPTIONS } from 'graph_ql/feedback_options/queries';
import { Collection } from '../../user_reactions/types';
import { CREATE_FEEDBACK } from 'graph_ql/feedback/mutations';
import { StyleStatus } from '../../../__generated__/globalTypes';

interface IStyleInformationProps {
    handleCloseModal?: () => void;
    styleData?: any;
    sourceStyleData?: any;
    isEdit?: any;
}
export interface StyleProps {
    isShowPublishOption: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(() => ({
    contentPage: {
        padding: '20px',
        overflowY: 'scroll',
        height: '100%',
        paddingBottom: 24,
    },
    formGroup: {
        marginBottom: '6px',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    lastFormGroup: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    groupButton: {
        textAlign: 'center',
        width: '100%',
        padding: '20px 32px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 56,
    },
    roundContainedBtn: {
        marginBottom: 8,
        width: '100%',
        height: '48px',
        padding: '0',
        textAlign: 'center',
        color: themes.palette.common.white,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        border: `1px solid`,
        borderRadius: '29px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    roundOutlineBtn: {
        marginTop: 8,
        width: '100%',
        height: '48px',
        padding: '15px 0',
        textAlign: 'center',
        color: themes.palette.primary.main,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: 'none',
        border: '1px solid',
        borderRadius: '29px',
    },
    iconArrowUp: {
        width: '52px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        borderLeft: '1px solid #CCDADB',
        paddingLeft: 16,
        '& path': {
            stroke: themes.palette.common.white,
        },
    },
    publishText: {
        flex: 1,
    },
    publishOptionGroup: {
        display: ({ isShowPublishOption }) => (isShowPublishOption ? 'flex' : 'none'),
        justifyContent: 'space-around',
        borderRadius: '8px',
        flexDirection: 'column',
        padding: '0 8px',
        backgroundColor: themes.palette.primary.main,
        position: 'absolute',
        height: '88px',
        top: '-96px',
        right: 0,
        left: 0,
        color: themes.palette.common.white,
        '& div:first-child': {
            borderBottom: '1px solid #fff',
        },
        '& div': {
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: themes.palette.common.white,
            fontSize: '12px',
            fontWeight: 400,
        },
    },
}));

const StyleInformation = ({ handleCloseModal, styleData, sourceStyleData }: IStyleInformationProps) => {
    const inReviewStyleImage = useAppSelector((state) => state.createStyle.createStyleCanvasImageUrl);
    const locationState = useLocation<{ reviewAction?: StyleReviewAction }>().state ?? {};
    const inReview = locationState.reviewAction && locationState.reviewAction === StyleReviewAction.Approve;
    const [isUpdating, setIsUpdating] = useState(false);
    const [prevGender, setPrevGender] = useState<any>(null);
    const [styleStatus, setStyleStatus] = useState(ItemStatus.Draft);
    const [showPopup, setShowPopup] = useState(false);
    const [saveStyle, setSaveStyle] = useState(false);
    const [consumersIds, setConsumersIds] = useState<any>(styleData?.consumersId || []);
    const url = utils.getShareEntityUrl('/style', styleData?.taffiId);
    const [isSubmitDraftLoading, setDraftLoading] = useState(false);
    const [isSubmitPublishLoading, setPublishLoading] = useState(false);
    const [isShowPublishOption, setIsShowPublishOption] = useState(false);
    const [isShowPublishUnlisted, setIsShowPublishUnlisted] = useState(false);
    const [isShowPublishPrivate, setIsShowPublishPrivate] = useState(false);
    const history = useHistory();
    const dispatch = useAppDispatch();
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        path: '',
        type: '',
        closeButton: true,
    });

    const { items: styleItems, imageJson } = useAppSelector((state) => state.createStyle);

    const compareResult: { itemChangePositionText: string; listRemovedItems: string[] } | null = useMemo(() => {
        if (imageJson && sourceStyleData) {
            return utils.compareStyleItems(sourceStyleData, imageJson);
        }
        return null;
    }, [sourceStyleData, imageJson]);

    const [createFeedback] = useMutation(CREATE_FEEDBACK, utils.gqlMutationOption({}));

    const [getStyleFeedbackOptions] = useLazyQuery(GET_FEEDBACK_OPTIONS, {
        fetchPolicy: 'network-only',
        onCompleted: async (response) => {
            if (response?.getFeedbackOptions.length) {
                const inappropriateOption = response?.getFeedbackOptions.find(
                    (option) => option.value === INAPPROPRIATE_LAYOUT_FEEDBACK_VALUE,
                );
                if (inappropriateOption) {
                    if (compareResult && compareResult.itemChangePositionText !== '') {
                        await Promise.all([
                            updateStyleMutation({
                                variables: {
                                    input: {
                                        id: sourceStyleData?.id,
                                        status: ItemStatus.RejectedFixed,
                                    },
                                },
                            }),
                            createFeedback({
                                variables: {
                                    input: {
                                        collectionName: Collection.Styles,
                                        docId: sourceStyleData?.id,
                                        contextType: PRODUCT_TYPE.STYLE,
                                        contextId: sourceStyleData?.id,
                                        contextTaffiId: sourceStyleData?.taffiId,
                                        feedbackReasonIds: [inappropriateOption.id],
                                        feedbackSubReason: compareResult.itemChangePositionText,
                                    },
                                },
                            }),
                        ]);
                        history.push(PATH.CREATE_STYLE_PUBLISH, {
                            reviewAction: StyleReviewAction.Reject,
                        });
                    }
                }
            }
        },
        onError(error) {
            console.error('Get Feedback Options For Styles Error', error);
        },
    });

    const [toggleReactionMutation] = useMutation(TOGGLE_REACTION, utils.gqlMutationOption({}));

    const getPersonaSubject = (gender) => {
        if (gender === 'Man') {
            return 'PERSONAS_MALE';
        } else {
            return 'PERSONAS_FEMALE';
        }
    };

    const handleSaveStyleOption = (value: ItemStatus) => {
        setStyleStatus(value);
        setSaveStyle(true);
        setShowPopup(false);
    };

    const publishOptions = [
        {
            title: 'Publish to Taffi',
            value: ItemStatus.Published,
            handleClick: (value) => handleSaveStyleOption(value),
        },
    ];

    if (!inReview && !styleData.sourceId) {
        publishOptions.push(
            ...[
                {
                    title: 'Publish Unlisted',
                    value: ItemStatus.PublishToUnlisted,
                    handleClick: (value) => handleSaveStyleOption(value),
                },
                {
                    title: 'Publish to a Consumer',
                    value: ItemStatus.PublishToConsumers,
                    handleClick: (value) => handleSaveStyleOption(value),
                },
            ],
        );
    }

    // const [personasSearch, { data: personasData }] = useLazyQuery(GET_PERSONAS)
    // const [purposeSearch, { data: purposeData }] = useLazyQuery(GET_PERSONAS)
    const { data: tagData } = useQuery(GET_TAG, {
        variables: { field: 'name', value: '' },
        fetchPolicy: 'network-only',
    });
    const { data: categoryData } = useQuery(GET_CATEGORY, {
        variables: { field: 'name', value: '' },
        fetchPolicy: 'network-only',
    });
    const { data: ageData } = useQuery(GET_PERSONAS, {
        variables: {
            field: 'title',
            value: '',
            subject: TaffiSubjects.TAFFI_AGE,
            paging: { page: 0, size: 50 },
        },
    });

    const { data: seasonData } = useQuery(GET_PERSONAS, {
        variables: {
            field: 'title',
            value: '',
            subject: TaffiSubjects.TAFFI_SEASON,
            paging: { page: 0, size: 50 },
        },
    });
    const { data: genderData } = useQuery(GET_PERSONAS, {
        variables: {
            field: 'title',
            value: '',
            subject: TaffiSubjects.TAFFI_GENDER,
            paging: { page: 0, size: 50 },
        },
    });

    const { data: purposeData } = useQuery(GET_QUESTION_DATA, {
        variables: {
            input: {
                subject: TaffiSubjects.TAFFI_PURPOSE,
                field: 'title',
                paging: { page: 0, size: 0 },
            },
        },
    });

    useEffect(() => {
        setPrevGender(get(styleData, ['genders'], []).map((d) => d.id));
    }, [styleData]);

    const defaultValues = useMemo(
        () => ({
            title: styleData?.title,
            description: styleData?.description,
            categoriesId: get(styleData, ['categories'], []).map(getValueSelect),
            purposesId: get(styleData, ['purposes'], []).map(getValueSelect),
            agesId: get(styleData, ['ages'], []).map((d) => d.id),
            seasonsId: get(styleData, ['seasons'], []).map((d) => d.id),
            gendersId: get(styleData, ['genders'], []).map((d) => d.id),
            personasId: get(styleData, ['personas'], []).map(getValueSelect),
            bodyShapesId: get(styleData, ['bodyShapes'], []).map((d) => d.id),
            bodyTypesId: get(styleData, ['bodyTypes'], []).map((d) => d.id),
            tagsId: get(styleData, ['tags'], []).map(getValueSelect),
            status: ItemStatus.Draft,
        }),
        [styleData],
    );
    const {
        control,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
        getValues,
    } = useForm({ defaultValues });
    const selectedGenders = watch('gendersId');
    const getSelectedGenderValue = useMemo(() => {
        if (selectedGenders && selectedGenders.length > 0 && genderData) {
            return selectedGenders.map(
                (genderId) => genderData.getQuestionData.data.find((genderData) => genderData.id === genderId)?.value,
            )[0];
        } else {
            return '';
        }
    }, [genderData, selectedGenders]);
    const [personaSearchInput, setPersonaSearchInput] = useState('');
    const { data: personasData, refetch: refetchPersonas } = useQuery(GET_QUESTION_DATA, {
        variables: {
            input: {
                subject: getPersonaSubject(getSelectedGenderValue),
                paging: { page: 0, size: 0 },
                title: personaSearchInput,
                field: 'title',
                value: '',
            },
        },
    });

    const tagOptions = useMemo(() => (tagData?.searchTag?.data || []).map(getValueSelect), [tagData?.searchTag?.data]);
    const categoryOptions = useMemo(
        () => (categoryData?.searchCategory?.data || []).map(getValueSelect),
        [categoryData?.searchCategory?.data],
    );
    const purposeOptions = useMemo(
        () => (purposeData?.getQuestionData?.data || []).map(getValueSelect),
        [purposeData?.getQuestionData?.data],
    );
    const personasOptions = useMemo(
        () => (personasData?.getQuestionData?.data || []).map(getValueSelect),
        [personasData?.getQuestionData?.data],
    );

    const { data: bodyShapesData, refetch: refetchBodyShapes } = useQuery(GET_PERSONAS, {
        variables: {
            field: 'title',
            value: '',
            subject: TaffiSubjects.TAFFI_BODY_SHAPES,
            paging: { page: 0, size: 50 },
            tags: [getSelectedGenderValue],
        },
    });

    const { data: bodyTypesData } = useQuery(GET_PERSONAS, {
        variables: {
            field: 'title',
            value: '',
            subject: TaffiSubjects.TAFFI_BODY_TYPES,
            paging: { page: 0, size: 50 },
            tags: [getSelectedGenderValue],
        },
    });

    useEffect(() => {
        if (prevGender && selectedGenders && !isEqual(selectedGenders, prevGender)) {
            refetchPersonas();
            refetchBodyShapes();
            setValue('bodyShapesId', []);
            setValue('bodyTypesId', []);
            setValue('personasId', []);
        }
        // eslint-disable-next-line
    }, [getSelectedGenderValue]);

    const classes = useStyles({ isShowPublishOption });
    const [updateStyleMutation] = useMutation(UPDATE_STYLE, utils.gqlMutationOption({}));

    const shouldShowGenderExpandedFields = useMemo(() => {
        const selectedGender = getSelectedGenderValue;
        if (!selectedGender) {
            return true;
        }

        return selectedGender === 'Man' || selectedGender === 'Woman';
        // eslint-disable-next-line
    }, [selectedGenders, genderData]);

    const imageUrl = useAppSelector((state) => state.createStyle.styleImg);
    const preventPublishStyleAlert = (consumerItem) => {
        setIsUpdating(false);
        setPublishLoading(false);
        setPopupData({
            show: true,
            title: 'Something went wrong.',
            content: `This style contains item from the consumer ${consumerItem.data.user.firstName}'s wardrobe. So this style can only be published to the consumer '${consumerItem.data.user.firstName}'.`,
            button1: 'Okay',
            button2: '',
            path: '',
            type: ToastType.Error,
            closeButton: true,
        });
    };
    const onSubmit = async (value: IStyleInformation) => {
        const consumerItem = styleItems
            .filter((item) => item != null)
            .find((item) => item.data?.user?.userType === UserType.Customer);

        setIsUpdating(true);
        if (styleStatus === ItemStatus.Draft) {
            setDraftLoading(true);
        }
        if (styleStatus === ItemStatus.Published) {
            setPublishLoading(true);
        }
        const submitValue: any = {
            ...value,
            categoriesId: value.categoriesId.map((c: any) => ({
                ...(c.id ? { id: c.id } : {}),
                name: c.value,
            })),
            tagsId: value.tagsId.map((c: any) => ({
                ...(c.id ? { id: c.id } : {}),
                name: c.value,
            })),
            agesId: value.agesId.map((id: any) => ({
                id: id,
            })),
            seasonsId: value.seasonsId.map((id: any) => ({
                id: id,
            })),
            personasId: value.personasId.map((c: any) => ({
                ...(c.id ? { id: c.id } : {}),
                value: c.value,
                subject: c.subject,
            })),
            purposesId: value.purposesId.map((c: any) => ({
                ...(c.id ? { id: c.id } : {}),
                value: c.value,
            })),
            bodyShapesId: value.bodyShapesId.map((id: any) => ({
                id: id,
            })),
            bodyTypesId: value.bodyTypesId.map((id: any) => ({
                id: id,
            })),
            gendersId: value.gendersId.map((id: any) => ({
                id: id,
            })),
            status: styleStatus,
            id: styleData.id,
            isReviewer: inReview,
        };
        let styleImage = imageUrl;
        if (inReview) {
            styleImage = inReviewStyleImage;
        }
        if (styleImage) {
            submitValue.images = [styleImage];
            submitValue.imageJson = imageJson;
        }

        try {
            if (
                styleStatus === ItemStatus.ChoosePublishOption ||
                styleStatus === ItemStatus.PublishToUnlisted ||
                styleStatus === ItemStatus.PublishToConsumers
            ) {
                setIsUpdating(false);
                setIsShowPublishOption(!isShowPublishOption);
                if (styleStatus === ItemStatus.ChoosePublishOption) return;
                if (styleStatus === ItemStatus.PublishToUnlisted && !isShowPublishUnlisted) {
                    if (consumerItem) {
                        preventPublishStyleAlert(consumerItem);
                        return;
                    }
                    setIsShowPublishUnlisted(true);
                    return;
                }
                if (styleStatus === ItemStatus.PublishToConsumers && !isShowPublishPrivate) {
                    setIsShowPublishPrivate(true);
                    return;
                }
            }

            // Only `Publish to consumer` is allowed if the style contains an item that belongs to a consumer.
            // and check if the consumer selected to publish is not the owner of the item in the style
            if (
                consumerItem &&
                (![ItemStatus.PublishToConsumers, ItemStatus.Draft].includes(styleStatus) ||
                    (ItemStatus.PublishToConsumers === styleStatus &&
                        !(consumersIds.length === 1 && consumersIds[0] === consumerItem.data.creator)))
            ) {
                preventPublishStyleAlert(consumerItem);
                return;
            }

            if (styleStatus === ItemStatus.PublishToConsumers || styleStatus === ItemStatus.PublishToUnlisted) {
                setPublishLoading(true);
                if (styleStatus === ItemStatus.PublishToConsumers) submitValue.consumersId = [...new Set(consumersIds)];
            }

            if (inReview) {
                await toggleReactionMutation({
                    variables: {
                        input: {
                            collectionName: 'styles',
                            docId: styleData?.id,
                            type: ReactionType.Approved,
                            contextType: PRODUCT_TYPE.STYLE,
                            contextId: styleData?.id,
                            contextTaffiId: styleData?.taffiId,
                        },
                    },
                });
            }

            let finalValues = submitValue;
            if (
                styleData.creator !== process.env.REACT_APP_SHOPIFY_STYLIST_ID &&
                styleData?.sourceId &&
                compareResult &&
                compareResult.listRemovedItems.length
            ) {
                finalValues = omit(submitValue, 'status');
            }

            if (styleData.status === StyleStatus.unlisted && styleStatus === ItemStatus.Published) {
                finalValues.isReviewer = true;
            }

            const res = await updateStyleMutation({
                variables: {
                    input: finalValues,
                },
            });
            if (res.errors) {
                console.error(res.errors);
                dispatch(clearLastCreatedStyleInfo());
                setIsUpdating(false);
                if (styleStatus === ItemStatus.Draft) {
                    setDraftLoading(false);
                }
                if (
                    styleStatus === ItemStatus.Published ||
                    styleStatus === ItemStatus.PublishToConsumers ||
                    styleStatus === ItemStatus.PublishToUnlisted
                ) {
                    setPublishLoading(false);
                }
            } else {
                // set last create style id
                dispatch(
                    setLastCreatedStyleInfo({
                        taffiId: res.data.updateStyle.taffiId,
                        status: styleStatus,
                        consumers:
                            styleStatus === ItemStatus.PublishToConsumers
                                ? res.data?.updateStyle?.consumers
                                : undefined,
                    }),
                );

                if (
                    styleData.creator !== process.env.REACT_APP_SHOPIFY_STYLIST_ID &&
                    styleData.sourceId &&
                    styleStatus === ItemStatus.Published
                ) {
                    if (compareResult && compareResult.listRemovedItems.length) {
                        // Redirect to the style feedback page if there are some items removed from the source style
                        history.push(PATH.STYLE_REVIEW, {
                            sourceId: styleData?.sourceId,
                            fixedStyleId: styleData?.id,
                        });
                    } else {
                        await getStyleFeedbackOptions({
                            variables: {
                                input: {
                                    targetType: [Collection.Styles],
                                    userTypes: [UserType.Stylist],
                                },
                            },
                        });
                    }
                } else {
                    if (inReview || styleData.sourceId) {
                        dispatch(setLastReviewStyleIds(inReview ? styleData.id : styleData.sourceId));
                        history.push(PATH.CREATE_STYLE_PUBLISH, {
                            reviewAction:
                                styleData.creator !== process.env.REACT_APP_SHOPIFY_STYLIST_ID && styleData.sourceId
                                    ? StyleReviewAction.Reject
                                    : StyleReviewAction.Approve,
                        });
                    } else {
                        history.push(PATH.CREATE_STYLE_PUBLISH);
                    }
                }
            }
        } catch (e) {
            console.error(e);
            setIsUpdating(false);
            if (styleStatus === ItemStatus.Draft) {
                setDraftLoading(false);
            }
            if (styleStatus === ItemStatus.Published) {
                setPublishLoading(false);
            }
            setPopupData({
                show: true,
                title: 'Something went wrong. ',
                content: 'There is an issue editing style. Please try again.',
                button1: 'Okay',
                button2: '',
                path: '',
                type: ToastType.Error,
                closeButton: true,
            });
        }
    };

    useEffect(() => {
        if (saveStyle) {
            setSaveStyle(false);
            handleSubmit((data) => onSubmit(data))();
        }
        // eslint-disable-next-line
    }, [saveStyle, getValues]);

    const handleCloseBtnClick = () => {
        if (handleCloseModal) handleCloseModal();
    };
    return (
        <>
            <CustomLayout
                title="Style Information"
                hideBottomNav={true}
                headerLeftBtn={
                    <CloseIcon
                        style={{ color: themes.palette.primary.main }}
                        onClick={() => {
                            handleCloseBtnClick();
                        }}
                    />
                }
            >
                <form onSubmit={handleSubmit(onSubmit)} className={classes.contentPage}>
                    <div className={classes.formGroup}>
                        <Controller
                            name="title"
                            control={control}
                            rules={{
                                required: { value: true, message: '' },
                            }}
                            render={({ field, fieldState }) => (
                                <StandardTextFieldStyle
                                    label="Style Title"
                                    variant="standard"
                                    size={'small'}
                                    {...field}
                                    error={!!fieldState.error}
                                    InputLabelProps={{
                                        style: {
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            width: '100%',
                                            color: !!fieldState.error ? 'red' : themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                        },
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className={classes.lastFormGroup}>
                        <Controller
                            name="description"
                            control={control}
                            rules={{
                                required: { value: true, message: '' },
                            }}
                            render={({ field, fieldState }) => (
                                <StandardTextFieldStyle
                                    label="Description"
                                    variant="standard"
                                    multiline
                                    size={'small'}
                                    {...field}
                                    error={!!fieldState.error}
                                    InputLabelProps={{
                                        style: {
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            width: '100%',
                                            color: !!fieldState.error ? 'red' : themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                        },
                                    }}
                                />
                            )}
                        />
                    </div>
                    <Controller
                        name="categoriesId"
                        control={control}
                        rules={{
                            required: { value: true, message: '' },
                        }}
                        render={({ field, fieldState }) => (
                            <CustomizeSelectData
                                data={categoryOptions}
                                handleSelectItem={(list) => {
                                    field.onChange(list);
                                }}
                                error={!!fieldState.error}
                                field="categories"
                                placeholder="Categories"
                                onChangeInput={() => null}
                                defaultValue={watch('categoriesId')}
                                anchorId="categories-select"
                            />
                        )}
                    />

                    <Controller
                        name="purposesId"
                        control={control}
                        rules={{
                            required: { value: true, message: '' },
                        }}
                        render={({ field, fieldState }) => (
                            <CustomizeSelectData
                                data={purposeOptions}
                                handleSelectItem={(list) => {
                                    field.onChange(list);
                                }}
                                error={!!fieldState.error}
                                field="purposes"
                                placeholder="Purposes"
                                onChangeInput={() => null}
                                defaultValue={watch('purposesId')}
                                anchorId="purpose-select"
                            />
                        )}
                    />

                    <Controller
                        name="gendersId"
                        control={control}
                        rules={{
                            required: { value: true, message: '' },
                        }}
                        render={({ field, fieldState }) => {
                            return (
                                <SelectMultipleDropDown
                                    placeholder={'Gender'}
                                    listSelectedValue={field.value || []}
                                    onChange={(newValue) => field.onChange(newValue)}
                                    error={!!fieldState.error}
                                    anchorId="gender-select"
                                    isSingle={true}
                                >
                                    {genderData &&
                                    genderData.getQuestionData &&
                                    genderData.getQuestionData?.data?.length > 0 ? (
                                            genderData.getQuestionData?.data.map((size, index) => (
                                                <SelectOption value={size.id} label={size.title} key={`size_${index}`} />
                                            ))
                                        ) : (
                                            <></>
                                        )}
                                </SelectMultipleDropDown>
                            );
                        }}
                    />
                    {shouldShowGenderExpandedFields && (
                        <Controller
                            name="personasId"
                            control={control}
                            rules={{
                                required: { value: true, message: '' },
                            }}
                            render={({ field, fieldState }) => {
                                return (
                                    <CustomizeSelectData
                                        data={personasOptions}
                                        handleSelectItem={(list) => {
                                            field.onChange(
                                                list.map((p) => ({
                                                    ...p,
                                                    subject: p.subject || getPersonaSubject(getSelectedGenderValue),
                                                })),
                                            );
                                        }}
                                        error={!!fieldState.error}
                                        field="personas"
                                        placeholder="Personas"
                                        onChangeInput={(input, value) => {
                                            _.debounce(() => {
                                                setPersonaSearchInput(value);
                                            }, 500);
                                        }}
                                        defaultValue={watch('personasId')}
                                        anchorId="personas-select"
                                    />
                                );
                            }}
                        />
                    )}

                    <Controller
                        name="tagsId"
                        control={control}
                        render={({ field, fieldState }) => (
                            <CustomizeSelectData
                                data={tagOptions}
                                handleSelectItem={(list) => {
                                    field.onChange(list);
                                }}
                                error={!!fieldState.error}
                                field="tags"
                                placeholder="Tags"
                                onChangeInput={() => null}
                                defaultValue={watch('tagsId')}
                                anchorId="tags-select"
                            />
                        )}
                    />

                    <Controller
                        name="agesId"
                        control={control}
                        rules={{
                            required: { value: true, message: '' },
                        }}
                        render={({ field, fieldState }) => (
                            <SelectMultipleDropDown
                                placeholder={'Ages'}
                                listSelectedValue={field.value || []}
                                onChange={field.onChange}
                                error={!!fieldState.error}
                                anchorId="ages-select"
                            >
                                {ageData && ageData.getQuestionData && ageData.getQuestionData?.data?.length > 0 ? (
                                    ageData.getQuestionData?.data.map((size, index) => (
                                        <SelectOption value={size.id} label={size.title} key={`size_${index}`} />
                                    ))
                                ) : (
                                    <></>
                                )}
                            </SelectMultipleDropDown>
                        )}
                    />
                    {shouldShowGenderExpandedFields && (
                        <>
                            <Controller
                                name="bodyShapesId"
                                control={control}
                                rules={{
                                    required: { value: true, message: '' },
                                }}
                                render={({ field, fieldState }) => (
                                    <SelectMultipleDropDown
                                        placeholder={'Body Shape'}
                                        listSelectedValue={field.value || []}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        anchorId="bodyshape-select"
                                    >
                                        {bodyShapesData &&
                                        bodyShapesData.getQuestionData &&
                                        bodyShapesData.getQuestionData?.data?.length > 0 ? (
                                                bodyShapesData.getQuestionData?.data
                                                    .slice()
                                                    .sort(utils.sortFilterObjectArray)
                                                    .map((size, index) => (
                                                        <SelectOption
                                                            value={size.id}
                                                            label={size.title}
                                                            key={`size_${index}`}
                                                        />
                                                    ))
                                            ) : (
                                                <></>
                                            )}
                                    </SelectMultipleDropDown>
                                )}
                            />
                            <Controller
                                name="bodyTypesId"
                                control={control}
                                rules={{
                                    required: { value: true, message: '' },
                                }}
                                render={({ field, fieldState }) => (
                                    <SelectMultipleDropDown
                                        placeholder={'Body Types'}
                                        listSelectedValue={field.value || []}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        anchorId="body-type-select"
                                    >
                                        {bodyTypesData &&
                                        bodyTypesData.getQuestionData &&
                                        bodyTypesData.getQuestionData?.data?.length > 0 ? (
                                                bodyTypesData.getQuestionData?.data
                                                    .slice()
                                                    .sort(utils.sortFilterObjectArray)
                                                    .map((size, index) => (
                                                        <SelectOption
                                                            value={size.id}
                                                            label={size.title}
                                                            key={`size_${index}`}
                                                        />
                                                    ))
                                            ) : (
                                                <></>
                                            )}
                                    </SelectMultipleDropDown>
                                )}
                            />
                        </>
                    )}

                    <Controller
                        name="seasonsId"
                        control={control}
                        rules={{
                            required: { value: true, message: '' },
                        }}
                        render={({ field, fieldState }) => (
                            <SelectMultipleDropDown
                                placeholder={'Season'}
                                listSelectedValue={field.value || []}
                                onChange={field.onChange}
                                error={!!fieldState.error}
                                anchorId="seasons-select"
                            >
                                {seasonData &&
                                seasonData.getQuestionData &&
                                seasonData.getQuestionData?.data?.length > 0 ? (
                                        seasonData.getQuestionData?.data.map((size, index) => (
                                            <SelectOption value={size.id} label={size.title} key={`size_${index}`} />
                                        ))
                                    ) : (
                                        <></>
                                    )}
                            </SelectMultipleDropDown>
                        )}
                    />
                    {Object.keys(errors).length > 0 && (
                        <p style={{ fontSize: '14px', color: 'red', position: 'relative', top: '24px' }}>
                            Please enter the highlighted fields.
                        </p>
                    )}
                    <div className={classes.groupButton}>
                        <button
                            id={'publish-popper'}
                            className={classes.roundContainedBtn}
                            disabled={isUpdating}
                            onClick={(e) => {
                                e.preventDefault();
                                if (publishOptions.length === 1 && publishOptions[0].value === ItemStatus.Published) {
                                    handleSaveStyleOption(ItemStatus.Published);
                                } else {
                                    setShowPopup(true);
                                }
                            }}
                        >
                            <span className={classes.publishText}>
                                Publish{' '}
                                {isSubmitPublishLoading && (
                                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                )}
                            </span>
                        </button>{' '}
                        {!inReview && !styleData.sourceId && (
                            <button
                                onClick={(e) => {
                                    setStyleStatus(ItemStatus.Draft);
                                    handleSubmit((data) => onSubmit(data));
                                }}
                                className={classes.roundOutlineBtn}
                                disabled={isUpdating}
                            >
                                {STRINGS.SAVE_TO_DRAFT}
                                {isSubmitDraftLoading && (
                                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                )}
                            </button>
                        )}
                    </div>
                    <ModalFull
                        open={isShowPublishUnlisted}
                        handleClose={() => setIsShowPublishUnlisted(!isShowPublishUnlisted)}
                        title="Publish Unlisted"
                        modal_code={ETitleModal.PUBLISH_TO_UNLISTED}
                        isEnableTitle={false}
                        componentProps={{
                            link: url,
                            isSubmitPublishLoading,
                            handleClose: () => setIsShowPublishUnlisted(!isShowPublishUnlisted),
                            onPublish: () => {
                                onSubmit(getValues());
                            },
                        }}
                    />
                </form>
                <StandardPopup
                    show={popupData.show}
                    onHide={() => setPopupData({ ...popupData, show: false })}
                    title={popupData.title}
                    content={popupData.content}
                    button1={popupData.button1}
                    button2={popupData.button2}
                    // path={popupData.path}
                    onSecondButtonClick={() => {
                        history.push(popupData.path);
                    }}
                    type={popupData.type as any}
                    closeButton={popupData.closeButton}
                />
                {isShowPublishPrivate && (
                    <ModalFull
                        open={isShowPublishPrivate}
                        handleClose={() => setIsShowPublishPrivate(!isShowPublishPrivate)}
                        title="Private"
                        modal_code={ETitleModal.PUBLISH_TO_CUSTOMER}
                        isEnableTitle={false}
                        componentProps={{
                            handleClose: () => setIsShowPublishPrivate(!isShowPublishPrivate),
                            onPublish: () => {
                                onSubmit(getValues());
                            },
                            setConsumersIds,
                            consumersIds,
                            isSubmitPublishLoading,
                            consumers:
                                styleData?.consumers?.map((item) => {
                                    return {
                                        id: item.id,
                                        fullName: `${item.firstName} ${item.lastName}`,
                                        avatar: getUserProfilePhoto(item),
                                    };
                                }) || [],
                        }}
                    />
                )}
            </CustomLayout>
            {showPopup && (
                <WidgetPopup
                    titlePopup={'Publish Style'}
                    widgetCode={WidgetCode.BottomPopupWidget}
                    listItem={publishOptions}
                    onClose={() => setShowPopup(false)}
                    shortPopup={true}
                />
            )}
        </>
    );
};

export default StyleInformation;
